var map = {
	"./angbao-bonus-cny.webp": 2502,
	"./angbao-bonus-dewali.webp": 2503,
	"./angbao-bonus-mooncake.webp": 2504,
	"./angbao-bonus-thaipusam.webp": 2505,
	"./angbao-bonus.webp": 2506,
	"./anni-lucky-draw.webp": 2507,
	"./cny-angbao-bonus.webp": 2508,
	"./cny-lucky-draw.webp": 2509,
	"./cny-promo.webp": 2510,
	"./dewali-promo.webp": 2511,
	"./dongzhi-angbao-bonus.webp": 2512,
	"./fifa-logo.webp": 2513,
	"./fifa-prediction.webp": 2514,
	"./fifa-qna.webp": 2515,
	"./uefa-predic.webp": 2516,
	"./welcome-cny-bonus.webp": 2517
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2501;